import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, Crown, ArrowRight } from "lucide-react";

const NEXT = { free: "pro", pro: "premium" };
const TIER = {
  pro: { name: "Pro", price: "$14.99/mo", perks: ["Match sites up to 50K visits", "50 swipes/day", "5 matches/day", "3 active slots"], Icon: Sparkles, accent: "primary" },
  premium: { name: "Premium", price: "$29.99/mo", perks: ["Match any traffic level", "Unlimited swipes", "10 matches/day", "6 active slots"], Icon: Crown, accent: "amber" },
};

export function nextTierOf(plan) {
  return NEXT[plan] || null;
}

export function PlanBadge() {
  const { user } = useAuth();
  const plan = user?.plan || "free";
  const styles = {
    free: "bg-white/5 text-muted-foreground border-white/10",
    pro: "bg-primary/15 text-primary border-primary/20",
    premium: "bg-amber-500/15 text-amber-400 border-amber-500/25",
  };
  return (
    <span data-testid="nav-plan-badge"
      className={`rounded-md text-[10px] font-mono font-semibold tracking-widest px-2 py-0.5 border ${styles[plan] || styles.free}`}>
      {plan.toUpperCase()}
    </span>
  );
}

export function UpgradeButton() {
  const { user } = useAuth();
  const nav = useNavigate();
  const next = nextTierOf(user?.plan || "free");
  if (!next) return null;
  const t = TIER[next];
  return (
    <button onClick={() => nav("/pricing")} data-testid="nav-upgrade-button"
      className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-primary/15 hover:bg-primary/25 text-primary border border-primary/25 px-3 py-1.5 text-xs font-semibold transition-colors">
      <t.Icon size={13} /> Upgrade
    </button>
  );
}

export function UpgradeBanner() {
  const { user } = useAuth();
  const nav = useNavigate();
  const next = nextTierOf(user?.plan || "free");
  if (!next) return null;
  const t = TIER[next];
  const isAmber = t.accent === "amber";
  return (
    <div data-testid="upgrade-banner"
      className={`mt-6 rounded-xl border p-5 flex flex-col sm:flex-row sm:items-center gap-4 justify-between ${isAmber ? "border-amber-500/25 bg-amber-500/[0.06]" : "border-primary/25 bg-primary/[0.05]"}`}>
      <div className="flex items-start gap-3">
        <div className={`h-10 w-10 rounded-lg border flex items-center justify-center shrink-0 ${isAmber ? "border-amber-500/30 bg-amber-500/10 text-amber-400" : "border-primary/25 bg-primary/10 text-primary"}`}>
          <t.Icon size={18} />
        </div>
        <div>
          <div className="font-serif font-semibold text-lg">Upgrade to {t.name} — {t.price}</div>
          <div className="text-sm text-muted-foreground mt-0.5">{t.perks.join(" · ")}</div>
        </div>
      </div>
      <button onClick={() => nav("/pricing")} data-testid="upgrade-banner-button"
        className={`shrink-0 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold text-white active:scale-95 transition-transform ${isAmber ? "bg-amber-500 hover:bg-amber-600" : "bg-primary hover:bg-blue-600"}`}>
        See {t.name} <ArrowRight size={15} />
      </button>
    </div>
  );
}
